<template>
    <div class="w100" style=" background: #fff2dd;"><!--01033c-->
        <article class="content-bg" style="padding-top: 40px;">
            <div class="logo-position">
                <img src="../../assets/images/ej/meetingLogo.png" alt="" srcset="" style="width: 200px">
                <p class="mt30">感谢有你</p>
                <p>共创辉煌</p>
                <div class="mt30"><span></span></div>
                <div><span></span></div>
                <div><span></span></div>
                <div><span></span></div>
            </div>
            <div class="logo-position textRight" style="right: 60px; left: auto;">
                <img src="../../assets/images/ej/meetingLogo.png" alt="" srcset="" style="width: 200px">
                <p class="mt30">感谢有你</p>
                <p>共创辉煌</p>
                <div class="mt30"><span></span></div>
                <div class=""><span></span></div>
                <div class=""><span></span></div>
                <div class=""><span></span></div>
            </div>
            <div class="wContent center">
                <div class="textCenter">
                    <img src="../../assets/images/ej/active2021ts.png" alt="" srcset="" style="width: 600px;"><br>
                    <img src="../../assets/images/ej/activeTitle1.png" alt="" srcset="" style="width: 770px;" class="mt30">
                    <p class="title-text mt40 fontWhite">2021 · 中国 · 唐山</p>
                    <!-- <p class="title-text-en mt10 fontWhite">WITHOUT BOUNDARIES</p> -->
                    <p class="time-text textCenter center mt40">时间： 2021年12月9-10日，地点：唐山香格里拉大酒店</p>
                </div>
                <div class="center meeting-jj">
                    <p class="textCenter meeting-jj-title">会议简介</p>
                    <p>即将过去的2021年是“十四五”开局之年，也是中国钢铁产业战略性变革极其重要的一年。碳达峰、碳中和作为未来中国经济社会发展的主基调，已经深刻影响中国钢铁产业发展路径。2021年，中国钢铁行业围绕高质量发展持续进步，并购重组加快推进，国际供应链安全问题得到改善，产品结构持续优化，企业效益继续保持良好水平。2021年，钢铁市场走出了波澜壮阔的行情，钢企限产有序推进，房地产退潮引发钢材表观需求持续萎缩，铁矿石与双焦成本支撑由强到弱，产业链大部分商品价格二、三季度分别创出历史新高，进入四季度又向下深度调整。市场宽幅震荡。<br></p>
                </div>

                <!-- <div class="mw-modular-box textCenter">
                    <img src="../../assets/images/ej/activity_tangshan2021/erweima.jpg" style="width: 300px" alt="" srcset="">
                </div> -->

                <div class="tab-box">
                    <span class="tab-i" :class="{'active': talkTab == 1}" @click="changeTalkTab(1)">主论坛</span>
                    <span class="tab-i" :class="{'active': talkTab == 2}" @click="changeTalkTab(2)">低碳（技术）论坛</span>
                    <span class="tab-i" :class="{'active': talkTab == 3}" @click="changeTalkTab(3)">矿焦市场分论坛</span>
                    <span class="tab-i" :class="{'active': talkTab == 4}" @click="changeTalkTab(4)">管带市场分论坛</span>
                    <span class="tab-i" :class="{'active': talkTab == 5}" @click="changeTalkTab(5)">坯型市场分论坛</span>
                </div>

                <!-- 主论坛 -->
                <div v-show="talkTab == 1">

                    <div class="meeting-yt">
                        <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -35px; margin-top: 10px">&nbsp;&nbsp;会&nbsp;&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;&nbsp;程</span></p>
                        <div class="meeting-yc-content center mt30">
                            <h2>
                                <span>全天</span><br>
                                <span>12月10日</span>
                            </h2>
                            <div class="line"></div>
                            <div>
                                <p class="time-line-content">
                                    <span class="fontRed font14">09:00 - 09:30</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        领导致辞<br>
                                        <span class="right-intro">
                                            曹妃甸区政府副区长曹妃甸自贸片区管委会副主任&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;刘子阳<br>
                                            河北唐宋大数据产业股份有限公司董事长&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;宋雷<br>
                                            唐山市钢铁协会会长、河钢集团唐钢公司董事长、党委书记&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;谢海深
                                        </span>
                                    </span>
                                    <a class="shuline" style="height: 170px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">09:30 - 10:00</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        讲话<br>
                                        <span class="right-intro">原冶金部副部长、全联冶金商会创会名誉会长 赵喜子</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">10:00 - 10:30</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《钢铁工业高质量发展与运行特点》<br>
                                        <span class="right-intro">中国钢铁工业协会副会长 屈秀丽</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">10:30 - 11:00</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        经验分享 《晋南钢铁低碳发展的经验启发》<br>
                                        <span class="right-intro">山西晋南钢铁集团有限公司总经理 张天福</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">11:00 - 11:30</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《全球钢铁行业低碳发展形势》<br>
                                        <span class="right-intro">世界钢铁协会中国区首席代表 钟绍良</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">11:30 - 12:00</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《钢铁行业的形势和政策解读》<br>
                                        <span class="right-intro">熔冶钢铁工业研究院首席专家、国资委管理局原局长 王连忠</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">12:00 - 13:30</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">午餐</span>
                                    <a class="shuline" style="height: 40px"></a>
                                </p>
                                <!-- <p class="time-line-content">
                                    <span class="fontRed font14">13:30 - 15:30</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">市场高端访谈：《周期下行：供给、需求、政策》</span>
                                    <span class="right-text">
                                        旭阳焦化集团有限公司营销副总经理&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 陈志胜<br>
                                        河北唐宋大数据产业股份有限公司董事长&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;宋雷<br>
                                        东证衍生品研究院执行副院长&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;孙枫<br>
                                        著名期货投资人&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;于忠
                                    </span>
                                    <a class="shuline" style="height: 170px;"></a>
                                </p> -->
                                <p class="time-line-content">
                                    <span class="fontRed font14">13:30 - 14:00</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《难以跨越的似曾相识：宏观形势展望》<br>
                                        <span class="right-intro">东证衍生品研究院执行副院长 孙枫</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">14:00 - 15:30</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        市场高端访谈：《周期下行：供给、需求、政策》<br>
                                        <span class="right-intro">
                                            旭阳焦化集团有限公司营销副总经理&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 陈志胜<br>
                                            河北唐宋大数据产业股份有限公司董事长&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;宋雷<br>
                                            东证衍生品研究院执行副院长&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;孙枫<br>
                                            著名期货投资人&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;于忠
                                        </span>
                                    </span>
                                    <a class="shuline" style="height: 210px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">15:30 - 15:40</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">唐宋学院外聘专家聘任仪式</span>
                                    <a class="shuline" style="height: 50px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">15:40 - 17:30</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">中国钢铁产业网十佳企业颁奖(含抽奖环节）</span>
                                    <a class="shuline" style="height: 50px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">18:00 - 20:00</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">晚宴</span>
                                    <!-- <a class="shuline" style="height: 40px"></a> -->
                                </p>
                            </div>                        
                        </div>
                    </div>

                    <div class="meeting-yt">
                        <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -30px; margin-top: 10px">&nbsp;领&nbsp;&nbsp;&nbsp;&nbsp;导&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;致&nbsp;&nbsp;&nbsp;&nbsp;辞</span></p>
                        <div class="meeting-jbjs center mt40">
                            <el-row :gutter="20" class="mw-modular-box">
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_zc_liuziyang.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">曹妃甸区政府副区长曹妃甸自贸片区管委会副主任 刘子阳</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_zc_songlei.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">河北唐宋大数据产业股份有限公司董事长 宋雷</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_zc_xiehaishen.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">唐山市钢铁协会会长、河钢集团唐钢公司董事长、党委书记 谢海深</p>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>

                    <div class="meeting-yt">
                        <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -30px; margin-top: 10px">&nbsp;演&nbsp;&nbsp;&nbsp;&nbsp;讲&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;嘉&nbsp;&nbsp;&nbsp;&nbsp;宾</span></p>
                        <div class="meeting-jbjs center mt40">
                            <el-row :gutter="20" class="mw-modular-box">
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_yj_zhaoxizi.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">原冶金部副部长、全联冶金商会创会名誉会长 赵喜子</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_yj_quxiuli.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">中国钢铁工业协会副会长 屈秀丽</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_yj_zhangtianfu.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">山西晋南钢铁集团有限公司总经理 张天福</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_yj_zhongshaoliang.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">世界钢铁协会中国区首席代表 钟绍良</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_yj_wanglianzhong.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">熔冶钢铁工业研究院首席专家、国资委管理局原局长 王连忠</p>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                    <div class="meeting-yt">
                        <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -30px; margin-top: 10px">&nbsp;现&nbsp;&nbsp;&nbsp;&nbsp;场&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;报&nbsp;&nbsp;&nbsp;&nbsp;道</span></p>
                        <div class="meeting-jbjs center mt40">
                            <el-row :gutter="20" class="mw-modular-box">
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_xc1.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_xc2.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_xc3.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_xc4.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_xc5.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_xc6.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_xc7.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_xc8.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_xc9.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_xc10.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_xc11.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_xc12.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_xc13.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_xc14.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/zhu_xc15.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
                <!-- 主论坛 -->

                <!-- 低碳(技术)论坛 -->
                <div v-show="talkTab == 2">

                    <div class="meeting-yt">
                        <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -35px; margin-top: 10px">&nbsp;&nbsp;会&nbsp;&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;&nbsp;程</span></p>
                        <div class="meeting-yc-content center mt30">
                            <h2>
                                <span>下午</span><br>
                                <span>12月9日</span>
                            </h2>
                            <div class="line"></div>
                            <div>
                                <!-- <p class="time-line-content">
                                    <span class="fontRed font14">14:00 - 14:15</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">领导致辞</span>
                                    <span class="right-text">
                                        熔冶钢铁工业研究院首席专家、国资委管理局原局长&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;王连忠
                                    </span>
                                    <a class="shuline" style="height: 90px;"></a>
                                </p> -->
                                <p class="time-line-content">
                                    <span class="fontRed font14">14:00 - 14:15</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        领导致辞<br>
                                        <span class="right-intro">
                                            熔冶钢铁工业研究院首席专家、国资委管理局原局长&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;王连忠
                                        </span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">14:15 - 14:50</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《推进钢铁企业碳素流程优化和碳管理体系建设》<br>
                                        <span class="right-intro">熔冶钢铁工业研究院总经理 马强博士</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">14:50 - 15:20</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《钢铁企业碳素流程优化》<br>
                                        <span class="right-intro">中国钢研科技集团钢铁绿色化智能化技术中心副主任 郦秀萍教授</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">15:20 - 15:50</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《钢铁企业如何参与全国碳市场交易》<br>
                                        <span class="right-intro">上海环境能源交易所</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">15:50 - 16:20</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《钢铁企业碳管理解决方案》<br>
                                        <span class="right-intro">上海宝碳新能源科技有限公司</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">16:20 - 16:50</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《钢铁和焦化行业碳达峰与碳中和之路》<br>
                                        <span class="right-intro">熔冶钢铁工业研究院专家济南钢铁集团原常务副总经理 温燕明</span>
                                    </span>
                                </p>
                            </div>                        
                        </div>
                    </div>

                    <div class="meeting-yt">
                        <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -30px; margin-top: 10px">&nbsp;领&nbsp;&nbsp;&nbsp;&nbsp;导&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;致&nbsp;&nbsp;&nbsp;&nbsp;辞</span></p>
                        <div class="meeting-jbjs center mt40">
                            <el-row :gutter="20" class="mw-modular-box">
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/ditan_zc_wanglianzhong.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">熔冶钢铁工业研究院首席专家国资委管理局原局长 王连忠</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/ditan_zc_zhaoxizi.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">原国家冶金局副局长、原国有重点大型企业监事会主席、全联冶金商会创会名誉会长 赵喜子</p>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>

                    <div class="meeting-yt">
                        <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -30px; margin-top: 10px">&nbsp;演&nbsp;&nbsp;&nbsp;&nbsp;讲&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;嘉&nbsp;&nbsp;&nbsp;&nbsp;宾</span></p>
                        <div class="meeting-jbjs center mt40">
                            <el-row :gutter="20" class="mw-modular-box">
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/ditan_yj_maqiang.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">河北唐宋大数据产业股份有限公司副总经理、熔冶钢铁工业研究院总经理 马强</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/ditan_yj_linhui.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">上海环境能源交易所原董事长 林辉(线上)</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/ditan_yj_zhuweiqing.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">上海宝碳新能源科技有限公司董事长 朱伟卿(线上)</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/ditan_yj_wenyanming.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">熔冶钢铁工业研究院专家、济南钢铁集团原常务副总经理 温燕明(线上)</p>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                    <div class="meeting-yt">
                        <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -30px; margin-top: 10px">&nbsp;现&nbsp;&nbsp;&nbsp;&nbsp;场&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;报&nbsp;&nbsp;&nbsp;&nbsp;道</span></p>
                        <div class="meeting-jbjs center mt40">
                            <el-row :gutter="20" class="mw-modular-box">
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/ditan_xc1.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/ditan_xc2.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/ditan_xc3.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/ditan_xc4.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/ditan_xc5.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/ditan_xc6.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/ditan_xc7.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/ditan_xc8.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
                <!-- 低碳(技术)论坛 -->

                <!-- 矿焦市场分论坛 -->
                <div v-show="talkTab == 3">

                    <div class="meeting-yt">
                        <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -35px; margin-top: 10px">&nbsp;&nbsp;会&nbsp;&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;&nbsp;程</span></p>
                        <div class="meeting-yc-content center mt30">
                            <h2>
                                <span>下午</span><br>
                                <span>12月9日</span>
                            </h2>
                            <div class="line"></div>
                            <div>
                                <!-- <p class="time-line-content">
                                    <span class="fontRed font14">14:00 - 14:10</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">领导致辞</span>
                                    <span class="right-text">
                                        河北唐宋大数据产业股份有限公司董事长&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;宋雷
                                    </span>
                                    <a class="shuline" style="height: 90px;"></a>
                                </p> -->
                                <p class="time-line-content">
                                    <span class="fontRed font14">14:00 - 14:40</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        领导致辞<br>
                                        <span class="right-intro">
                                            河北唐宋大数据产业股份有限公司董事长&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;宋雷<br>
                                            旭阳集团旭阳营销有限公司焦炭事业部总经理&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;王汉双
                                        </span>
                                    </span>
                                    <a class="shuline" style="height: 140px"></a>
                                </p>
                                <!-- <p class="time-line-content">
                                    <span class="fontRed font14">14:20 - 14:40</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《焦炭市场行情走势》<br>
                                        <span class="right-intro">旭阳集团旭阳营销有限公司焦炭事业部总经理 王汉双</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p> -->
                                <p class="time-line-content">
                                    <span class="fontRed font14">14:40 - 15:10</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《五矿曹妃甸精混匀矿项目及产品介绍》<br>
                                        <span class="right-intro">中国五矿集团（唐山曹妃甸）矿石控股有限公司副总经理 陈益辉</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">15:10 - 15:40</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《原燃料大幅涨跌下钢铁企业如何搞好原燃料采购》<br>
                                        <span class="right-intro">唐山港陆钢铁有限公司、信息科科长 徐文利</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">15:40 - 16:00</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">抽奖环节</span>
                                    <a class="shuline" style="height: 40px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">16:00 - 16:30</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《煤炭市场行情分析及展望》<br>
                                        <span class="right-intro">宁波浮沉黑色研究院总监 邴石川</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">16:30 - 17:00</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《矿石行业风险管理体系与案例分享》<br>
                                        <span class="right-intro">山东港信期货有限公司黑色产业研究员 魏兆晴</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">17:00 - 17:30</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">自由研讨环节</span>
                                </p>
                            </div>                        
                        </div>
                    </div>

                    <div class="meeting-yt">
                        <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -30px; margin-top: 10px">&nbsp;领&nbsp;&nbsp;&nbsp;&nbsp;导&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;致&nbsp;&nbsp;&nbsp;&nbsp;辞</span></p>
                        <div class="meeting-jbjs center mt40">
                            <el-row :gutter="20" class="mw-modular-box">
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/kuangjiao_zc_songlei.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">河北唐宋大数据产业股份有限公司董事长 宋雷</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/kuangjiao_yj_wanghanshuang.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">旭阳集团旭阳营销有限公司焦炭事业部总经理 王汉双</p>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>

                    <div class="meeting-yt">
                        <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -30px; margin-top: 10px">&nbsp;演&nbsp;&nbsp;&nbsp;&nbsp;讲&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;嘉&nbsp;&nbsp;&nbsp;&nbsp;宾</span></p>
                        <div class="meeting-jbjs center mt40">
                            <el-row :gutter="20" class="mw-modular-box">
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/kuangjiao_yj_chenyihui.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">中国五矿集团（唐山曹妃甸）矿石控股有限公司副总经理 陈益辉</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/kuangjiao_yj_xuwenli.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">唐山港陆钢铁有限公司、信息科科长 徐文利</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/kuangjiao_yj_bingshichuan.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">宁波浮沉黑色研究院总监 邴石川</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/kuangjiao_yj_weizhaoqing.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">山东港信期货有限公司黑色产业研究员 魏兆晴</p>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                    <div class="meeting-yt">
                        <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -30px; margin-top: 10px">&nbsp;现&nbsp;&nbsp;&nbsp;&nbsp;场&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;报&nbsp;&nbsp;&nbsp;&nbsp;道</span></p>
                        <div class="meeting-jbjs center mt40">
                            <el-row :gutter="20" class="mw-modular-box">
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/kuangjiao_xc1.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/kuangjiao_xc2.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/kuangjiao_xc3.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/kuangjiao_xc4.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/kuangjiao_xc5.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/kuangjiao_xc6.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/kuangjiao_xc7.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/kuangjiao_xc8.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/kuangjiao_xc9.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/kuangjiao_xc10.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
                <!-- 矿焦市场分论坛 -->

                <!-- 管带市场分论坛 -->
                <div v-show="talkTab == 4">

                    <div class="meeting-yt">
                        <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -35px; margin-top: 10px">&nbsp;&nbsp;会&nbsp;&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;&nbsp;程</span></p>
                        <div class="meeting-yc-content center mt30">
                            <h2>
                                <span>下午</span><br>
                                <span>12月9日</span>
                            </h2>
                            <div class="line"></div>
                            <div>
                                <!-- <p class="time-line-content">
                                    <span class="fontRed font14">13:00 - 14:00</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">嘉宾签到</span>
                                    <a class="shuline" style="height: 50px"></a>
                                </p> -->
                                <p class="time-line-content">
                                    <span class="fontRed font14">14:00 - 14:20</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        领导致辞<br>
                                        <span class="right-intro">
                                            唐山瑞丰钢铁（集团）有限公司副总经理&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;温瑞臣
                                        </span>
                                    </span>
                                    <a class="shuline" style="height: 220px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">14:20 - 14:50</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《回望“十三五” 奋进“十四五”》<br>
                                        <span class="right-intro">中国钢结构协会钢管分会副秘书长、正高级工程师 钟锡弟</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">14:50 - 15:20</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《2021年焊管行业现状及2022年趋势》<br>
                                        <span class="right-intro">天津友发钢管集团股份有限公司市场管理中心副总监 孔德刚</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">15:20 - 15:50</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《中国焊管行业发展趋势—和谐营销与品牌之争》<br>
                                        <span class="right-intro">邯郸正大制管集团股份有限公司经营中心副总监、迁安正大通用钢管有限公司副总经理 白向锋</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">15:50 - 16:20</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《不安定时代下引领结构钢管行业发展》<br>
                                        <span class="right-intro">天津源泰德润钢管制造集团有限公司华北大区经理 杨双双</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">16:20 - 16:30</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">抽奖环节</span>
                                    <a class="shuline" style="height: 40px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">16:30 - 16:40</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        讲话<br>
                                        <span class="right-intro">河北唐宋大数据产业股份有限公司董事长 宋雷</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">16:40 - 17:00</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《2021年热轧带钢市场分析及2022年展望》<br>
                                        <span class="right-intro">河北唐宋大数据产业股份有限公司高级分析师 王兰彩</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">17:00 - 17:30</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        讨论环节<br>
                                        <span class="right-intro">拟上中下游企业代表研讨</span>
                                    </span>
                                </p>
                            </div>                        
                        </div>
                    </div>

                    <div class="meeting-yt">
                        <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -30px; margin-top: 10px">&nbsp;领&nbsp;&nbsp;&nbsp;&nbsp;导&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;致&nbsp;&nbsp;&nbsp;&nbsp;辞</span></p>
                        <div class="meeting-jbjs center mt40">
                            <el-row :gutter="20" class="mw-modular-box">
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/guandai_zc_wenruichen.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">唐山瑞丰钢铁（集团）有限公司副总经理 温瑞臣</p>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>

                    <div class="meeting-yt">
                        <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -30px; margin-top: 10px">&nbsp;演&nbsp;&nbsp;&nbsp;&nbsp;讲&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;嘉&nbsp;&nbsp;&nbsp;&nbsp;宾</span></p>
                        <div class="meeting-jbjs center mt40">
                            <el-row :gutter="20" class="mw-modular-box">
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/guandai_yj_zhongxidi.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">中国钢结构协会钢管分会副秘书长、正高级工程师 钟锡弟</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/guandai_yj_kongdegang.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 90px;">天津友发钢管集团股份有限公司市场管理中心副总监 孔德刚</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/guandai_yj_baixiangfeng.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 90px;">邯郸正大制管集团股份有限公司经营中心副总监、迁安正大通用钢管有限公司副总经理 白向锋</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/guandai_yj_yangshuangshuang.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">天津源泰德润钢管制造集团有限公司华北大区经理 杨双双</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/guandai_yj_wanglancai.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 90px;">河北唐宋大数据产业股份有限公司高级分析师 王兰彩</p>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                    <div class="meeting-yt">
                        <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -30px; margin-top: 10px">&nbsp;现&nbsp;&nbsp;&nbsp;&nbsp;场&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;报&nbsp;&nbsp;&nbsp;&nbsp;道</span></p>
                        <div class="meeting-jbjs center mt40">
                            <el-row :gutter="20" class="mw-modular-box">
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/guandai_xc1.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/guandai_xc2.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/guandai_xc3.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/guandai_xc4.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/guandai_xc5.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/guandai_xc6.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/guandai_xc7.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/guandai_xc8.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
                <!-- 管带市场分论坛 -->

                <!-- 坯型市场分论坛 -->
                <div v-show="talkTab == 5">

                    <div class="meeting-yt">
                        <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -35px; margin-top: 10px">&nbsp;&nbsp;会&nbsp;&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;&nbsp;程</span></p>
                        <div class="meeting-yc-content center mt30">
                            <h2>
                                <span>下午</span><br>
                                <span>12月9日</span>
                            </h2>
                            <div class="line"></div>
                            <div>
                                <p class="time-line-content">
                                    <span class="fontRed font14">14:00 - 14:30</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        领导致辞<br>
                                        <span class="right-intro">
                                            河北唐宋大数据产业股份有限公司总经理助理&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;张品<br>
                                            秦皇岛宏兴钢铁有限公司营销副总&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;孙长东<br>
                                            河北津西钢铁集团股份有限公司品牌企划处处长&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;张云馨
                                        </span>
                                    </span>
                                    <a class="shuline" style="height: 170px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">14:30 - 15:00</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《钢坯生态资源变迁》<br>
                                        <span class="right-intro">秦皇岛佰工钢铁有限公司副总经理 毛汝男</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">15:00 - 15:30</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《我国＂十四五＂期间热轧型钢供需趋势分析》<br>
                                        <span class="right-intro">津西技术中心副主任/国家钢结构技术研究中心院长助理 赵一臣</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">15:30 - 15:40</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">抽奖环节</span>
                                    <a class="shuline" style="height: 40px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">15:40 - 16:10</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《进口钢坯的行业发展及策略》<br>
                                        <span class="right-intro">浙江物产道富有限公司研究部经理 肖灯标</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">16:10 - 16:30</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        讲话<br>
                                        <span class="right-intro">河北唐宋大数据产业股份有限公司董事长 宋雷</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">16:30 - 17:00</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">
                                        《钢材期现结合与应用》<br>
                                        <span class="right-intro">壹德商贸有限公司总经理 付博男</span>
                                    </span>
                                    <a class="shuline" style="height: 90px"></a>
                                </p>
                                <p class="time-line-content">
                                    <span class="fontRed font14">17:00 - 17:20</span>
                                    <span class="point"></span>
                                    <span class="fontRed font14">研讨环节</span>
                                </p>
                            </div>                        
                        </div>
                    </div>

                    <div class="meeting-yt">
                        <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -30px; margin-top: 10px">&nbsp;领&nbsp;&nbsp;&nbsp;&nbsp;导&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;致&nbsp;&nbsp;&nbsp;&nbsp;辞</span></p>
                        <div class="meeting-jbjs center mt40">
                            <el-row :gutter="20" class="mw-modular-box">
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_zc_zhangpin.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">河北唐宋大数据产业股份有限公司总经理助理 张品</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_zc_sunchangdong.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">秦皇岛宏兴销售副总 孙长东</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_zc_zhangyunxin.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">河北津西股份品牌企划处处长 张云馨</p>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>

                    <div class="meeting-yt">
                        <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -30px; margin-top: 10px">&nbsp;演&nbsp;&nbsp;&nbsp;&nbsp;讲&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;嘉&nbsp;&nbsp;&nbsp;&nbsp;宾</span></p>
                        <div class="meeting-jbjs center mt40">
                            <el-row :gutter="20" class="mw-modular-box">
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_yj_maorunan.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">秦皇岛佰工钢铁副总经理 毛汝男</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_yj_zhaoyichen.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">津西技术中心副主任国家钢结构技术研究中心院长助理 赵一臣</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_yj_xiaodengbiao.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">浙江物产道富有限公司研究部经理 肖灯标</p>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_yj_fubonan.jpg" alt="" srcset="" class="detail-user-img">
                                        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">壹德商贸总经理 付博男</p>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                    <div class="meeting-yt">
                        <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -30px; margin-top: 10px">&nbsp;现&nbsp;&nbsp;&nbsp;&nbsp;场&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;报&nbsp;&nbsp;&nbsp;&nbsp;道</span></p>
                        <div class="meeting-jbjs center mt40">
                            <el-row :gutter="20" class="mw-modular-box">
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_xc1.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_xc2.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_xc3.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_xc4.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_xc5.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_xc6.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_xc7.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_xc8.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_xc9.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_xc10.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_xc11.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_xc12.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_xc13.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_xc14.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_xc15.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_xc16.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_xc17.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_xc18.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="textCenter mb15">
                                        <img src="../../assets/images/ej/activity_tangshan2021/pixing_xc19.jpg" alt="" srcset="" class="detail-user-img">
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
                <!-- 坯型市场分论坛 -->


                <!-- 十佳颁奖 -->
                <div class="meeting-yt">
                    <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -30px; margin-top: 10px">&nbsp;精&nbsp;&nbsp;&nbsp;&nbsp;彩&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;仪&nbsp;&nbsp;&nbsp;&nbsp;式</span></p>
                    <div id="marqueeBox" name="marqueeBox" class="index-quote-list-box">
                        <div class="inlineBlock img-box" @click="showImgDetail(0)">
                            <img src="../../assets/images/ej/activity_tangshan2021/sj_bancai.jpg" alt="" height="150px">
                            <p>十佳板材供应商</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(1)">
                            <img src="../../assets/images/ej/activity_tangshan2021/sj_daigang.jpg" alt="" height="150px">
                            <p>十佳带钢供应商</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(2)">
                            <img src="../../assets/images/ej/activity_tangshan2021/sj_fuwu.jpg" alt="" height="150px">
                            <p>十佳服务企业</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(3)">
                            <img src="../../assets/images/ej/activity_tangshan2021/sj_gangguan.jpg" alt="" height="150px">
                            <p>十佳钢管供应商</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(4)">
                            <img src="../../assets/images/ej/activity_tangshan2021/sj_gangguanzhizao.jpg" alt="" height="150px">
                            <p>十佳钢管制造企业</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(5)">
                            <img src="../../assets/images/ej/activity_tangshan2021/sj_gangjiegoushengchan.jpg" alt="" height="150px">
                            <p>十佳钢结构生产企业</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(6)">
                            <img src="../../assets/images/ej/activity_tangshan2021/sj_gangpi.jpg" alt="" height="150px">
                            <p>十佳钢坯供应商</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(7)">
                            <img src="../../assets/images/ej/activity_tangshan2021/sj_gangtiejiagong.jpg" alt="" height="150px">
                            <p>十佳钢铁加工企业</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(8)">
                            <img src="../../assets/images/ej/activity_tangshan2021/sj_gangtiemaoyi.jpg" alt="" height="150px">
                            <p>十佳钢铁综合贸易企业</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(9)">
                            <img src="../../assets/images/ej/activity_tangshan2021/sj_gangtieshengchan.jpg" alt="" height="150px">
                            <p>十佳钢铁生产企业</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(10)">
                            <img src="../../assets/images/ej/activity_tangshan2021/sj_gangtiewuliu.jpg" alt="" height="150px">
                            <p>十佳钢铁物流企业</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(11)">
                            <img src="../../assets/images/ej/activity_tangshan2021/sj_jiancai.jpg" alt="" height="150px">
                            <p>十佳建材供应商</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(12)">
                            <img src="../../assets/images/ej/activity_tangshan2021/sj_jiaohua.jpg" alt="" height="150px">
                            <p>十佳焦化生产企业</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(13)">
                            <img src="../../assets/images/ej/activity_tangshan2021/sj_meijiao.jpg" alt="" height="150px">
                            <p>十佳煤焦供应商</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(14)">
                            <img src="../../assets/images/ej/activity_tangshan2021/sj_qihuo.jpg" alt="" height="150px">
                            <p>十佳期货企业</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(15)">
                            <img src="../../assets/images/ej/activity_tangshan2021/sj_tiekuangshi.jpg" alt="" height="150px">
                            <p>十佳铁矿石供应商</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(16)">
                            <img src="../../assets/images/ej/activity_tangshan2021/sj_xinggang.jpg" alt="" height="150px">
                            <p>十佳型钢供应商</p>
                        </div>
                    </div>
                    <!-- 十佳放大效果 -->
                    <el-dialog title="" :visible.sync="dialogVisible" width="40%">
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <div>
                                    <img :src="dialogImg" alt="" class="w100">
                                </div>
                            </el-col>
                            <!-- <el-col :span="8">
                                <p v-for="(item, index) in sjDetailData" :key="index" style="line-height: 50px; font-size: 18px; color: #333;">{{item}}</p>
                            </el-col> -->
                        </el-row>
                    </el-dialog>
                </div>

                 <!-- 唐宋学院外聘专家聘任仪式 -->
                <div class="meeting-yt">
                    <p class="meeting-yt-title1 meeting-yt-title center textCenter">
                        <span style="display: inline-block; margin-left: -20px; margin-top: 10px">
                            唐&nbsp;&nbsp;&nbsp;&nbsp;宋&nbsp;&nbsp;&nbsp;&nbsp;外&nbsp;&nbsp;&nbsp;&nbsp;聘&nbsp;&nbsp;&nbsp;&nbsp;专&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;家&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;聘&nbsp;&nbsp;&nbsp;&nbsp;任&nbsp;&nbsp;&nbsp;&nbsp;仪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;式</span>
                    </p>
                    <div class="meeting-jbjs center mt40">
                        <el-row :gutter="20" class="mw-modular-box">
                            <el-col :span="12">
                                <div class="textCenter">
                                    <img src="../../assets/images/ej/activity_tangshan2021/pinren1.jpg" alt="" srcset="" class="detail-user-img" style="height: 300px">
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="textCenter">
                                    <img src="../../assets/images/ej/activity_tangshan2021/pinren2.jpg" alt="" srcset="" class="detail-user-img" style="height: 300px">
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>


                <div class="meeting-yt">
                    <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -35px; margin-top: 10px">&nbsp;&nbsp;会&nbsp;&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;&nbsp;赞&nbsp;&nbsp;&nbsp;&nbsp;助</span></p>

                    <div class="meeting-zanzhu center textCenter">
                        <p class="zanzhu-title mt30">承办单位</p>
                        <el-row :gutter="20">
                            <el-col :span="8" :offset="8">
                                <div class="zanzhu-center">中国钢铁产业网</div>
                            </el-col>
                        </el-row>
                        <p class="zanzhu-subtitle mt30">联合主办</p>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <div class="zanzhu-left">河北唐宋大数据产业股份有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">熔冶（北京）钢铁工业研究院</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">中国(河北)自由贸易试验区曹妃甸片区管理委员会</div>
                            </el-col>
                        </el-row>
                        <p class="zanzhu-subtitle mt30">协办单位</p>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <div class="zanzhu-left">山西晋南钢铁集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">方同舟控股有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">秦皇岛宏兴钢铁有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-left">天津市新天钢联合特钢有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">中国五矿集团（唐山曹妃甸）矿石控股有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">德天（天津）国际贸易发展有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-left">天津友发钢管集团股份有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">天津源泰德润钢管制造集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">正大制管集团</div>
                            </el-col>
                        </el-row>

                        <p class="zanzhu-subtitle mt30">支持单位</p>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <div class="zanzhu-left">中国钢铁工业协会</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">全联冶金商会</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">唐山市钢铁工业协会</div>
                            </el-col>
                        </el-row>
                        <p class="zanzhu-subtitle mt30">赞助单位</p>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <div class="zanzhu-left">河北津西钢铁集团股份有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">敬业集团</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">山东泰山钢铁集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-left">河北天柱钢铁集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">河北东海特钢集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">河北鑫达钢铁集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-left">河北安丰钢铁有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">天津荣程联合钢铁集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">秦皇岛佰工钢铁有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-left">厦门建发金属有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">河北盛泰制管有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">山东港信期货有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-left">唐山盛财钢铁有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">中琉科技有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">一德期货有限公司</div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
            <div class="meeting-yt">
                <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -35px; margin-top: 10px">&nbsp;大&nbsp;&nbsp;&nbsp;&nbsp;会&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地&nbsp;&nbsp;&nbsp;&nbsp;点</span></p>
                <div class="meeting-address">
                    <div style="margin-top: 40px; color: #8e3837" class="mw-modular-box textCenter">
                        <h3 style="line-height: 40px; font-size: 24px">唐山香格里拉大酒店</h3>
                        <p style="line-height: 40px; font-size:24px">河北省唐山市路北区长虹西道887号、889号</p>
                        <p style="line-height: 40px; font-size:16px">会址距唐山三女河机场约 25分钟车程，距唐山火车站20分钟车程。</p>
                    </div>
                    <div class="address-bg textCenter">
                        <a href="https://map.baidu.com/poi/%E5%94%90%E5%B1%B1%E9%A6%99%E6%A0%BC%E9%87%8C%E6%8B%89%E5%A4%A7%E9%85%92%E5%BA%97/@13152973.355,4790494.665,13z?uid=eb1701ded3c1306d774ff18f&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&newfrom=zhuzhan_webmap&querytype=detailConInfo&da_src=shareurl" target="_blank">
                            <img src="../../assets/images/ej/activity_tangshan2021/address.jpg" alt="" srcset="" class="">
                        </a>
                    </div>
                </div>
            </div>
            <div class="meeting-yt">
                <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -35px; margin-top: 10px">&nbsp;会&nbsp;&nbsp;&nbsp;&nbsp;务&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联&nbsp;&nbsp;&nbsp;&nbsp;系</span></p>
                <div class="meeting-concat center font16 mt40" style="color: #8e3837">
                    <p class="textCenter" style="line-height: 40px;">
                        河北唐宋大数据产业股份有限公司&nbsp;&nbsp;&nbsp;&nbsp;会务联系人：王慧<br>
                        回执传真至：0315-5921091/92&nbsp;&nbsp;&nbsp;&nbsp;联系方式：18231525225
                    </p>
                    <el-row style="margin-top: 10px; padding-bottom: 30px;">
                        <el-col :span="8">
                            <div class="textCenter">
                                <img src="../../assets/images/act_code1.png" alt="" width="100px">
                                <small style="display: block;line-height: 40px;">在线监测预警公众号</small>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="textCenter">
                                <img src="../../assets/images/footer_down.png" alt="" width="100px">
                                <p style="line-height: 35px;">唐宋app</p>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="textCenter">
                                <img src="../../assets/images/footer_code.png" alt="" width="100px">
                                <p style="line-height: 35px;">唐宋大数据</p>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </article>

        <ConcatsControl></ConcatsControl>
    </div>
</template>
<script>

/*{
"img": "https://tangsong.chinatsi.net/static/billetzs/images/20211213/20211213133021965595.jpg",
"title": "2021年钢铁产业年终论坛暨中国钢铁产业网年会",
"oprator": "河北唐宋大数据产业股份有限公司、熔冶（北京）钢铁工业研究院、中国（河北）自由贸易试验区曹妃甸片区管理委员会联合主办",
"time": "2021年12月9-10日",
"address": "唐山香格里拉大酒店",
"members": "200",
"id": 7
},*/

import $ from 'jquery'
import QRCode from 'qrcode'
import '../../assets/js/jquery.liMarquee.js'
import { baseUrl, getQueryString, adIDs } from '../../assets/js/common'
import ConcatsControl from '../../templates/concatsControl'
export default {
    name: 'activitiesDetail2021ts',
    components: { ConcatsControl },
    data() {
        return {
            adIDsIndex: [{
                name: 'zx39',
                id: adIDs['zx39'],
                list: []
            }],
            liMarquee: null,
            dialogVisible: false,
            dialogImg: '',
            imgs: [
                require('../../assets/images/ej/activity_tangshan2021/sj_bancai.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_daigang.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_fuwu.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_gangguan.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_gangguanzhizao.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_gangjiegoushengchan.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_gangpi.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_gangtiejiagong.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_gangtiemaoyi.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_gangtieshengchan.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_gangtiewuliu.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_jiancai.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_jiaohua.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_meijiao.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_qihuo.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_tiekuangshi.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_xinggang.jpg')
            ],
            imgsDetailNames: [
                // ['河北普阳钢铁有限公司', '河北津西钢铁集团股份有限公司', '秦皇岛宏兴钢铁有限公司', '唐山市德龙钢铁有限公司', '山西晋南钢铁集团有限公司', '河北天柱钢铁集团有限公司', '天津荣程联合钢铁集团有限公司', '唐山东华钢铁企业集团有限公司', '河北安丰钢铁有限公司', '江苏徐钢钢铁集团有限公司'], // 钢铁生产企业
                // ['厦门海翼国际贸易有限公司', '浙江物产金属集团有限公司', '中基宁波集团股份有限公司', '成大物产（厦门）有限公司', '浙商中拓集团股份有限公司', '山东天保工贸有限公司', '天津启润投资有限公司', '苏美达国际技术贸易有限公司', '杭州热联集团股份有限公司', '江苏象石实业股份有限公司'], // 综合贸易企业
                // ['新绛天地和金属制品有限公司', '天津市群胜达钢管有限公司', '天津友发钢管集团股份有限公司', '山东舜世高科实业有限公司', 'ZDP正大制管有限公司', '霸州市众丰金属制品有限公司', '天津市可楠钢管有限公司', '天津市宝来工贸有限公司', '河北盛泰制管有限公司', '天津市利达钢管集团有限公司'], // 钢管制造企业
                // ['唐山海翼宏润物流有限公司', '浙江物产物流投资有限公司唐山分公司', '厦门国贸启铭物流有限公司', '唐山市丰领物流有限公司', '四川乐送物流股份有限公司', '河北兴泰物流有限公司', '唐山象屿正丰国际物流有限公司', '唐山市双赢物流有限公司', '邯郸新铁物流有限公司', '唐山东方海运有限公司'], // 钢铁物流企业
                // ['唐山友利焦化有限公司', '武安市广普焦化有限公司', '介休市昌盛煤气化有限公司', '山西安泰集团股份有限公司', '唐山东方炼焦制气有限公司', '乌海市广纳煤焦化有限公司', '河北华丰能源科技发展有限公司', '山西潞宝集团焦化有限公司', '唐山达丰焦化有限公司', '山西亚鑫煤焦化有限公司'], // 焦化生产企业
                // ['秦皇岛顺先钢铁有限公司', '天津市震翔板带加工有限公司', '唐山市丰润区鸿翔金属制品有限公司', '唐山首唐宝生功能材料有限公司', '唐山如隆实业有限公司', '唐山市丰润区鑫通源扁钢厂', '唐山宏润实业有限公司', '唐山市德物精密制品有限公司 ', '江苏卓群金属科技有限公司', '唐山市丰润区永强轧钢厂'], //钢加工企业
                // ['河北津西新材料科技有限公司', '泊头市宝发彩钢钢构工程有限公司', '庆云华兴钢架工程有限公司', '宏德瑞琳金属结构制造有限公司', '邯郸市银蝉贸易有限公司', '潍坊长安铁塔股份有限公司', '天津市鑫跃达工贸有限公司', '邯郸市泽业贸易有限公司', '邯郸市恒特板材加工有限公司', '邯郸市华威钢结构工程有限公司'], // 钢结构生产企业
                // ['本溪市远通物资回收有限公司', '朝阳议通金属再生资源有限公司', '天津城矿再生资源回收有限公司', '武安市永鑫再生资源利用有限公司', '天津德邦（邢台县）再生资源利用有限公司', '扬州鸿蓝钢铁加工有限公司', '天津振泓再生资源有限公司', '天津宏业兴再生物资回收有限公司', '浙商中拓集团江西再生资源有限公司', '河南冀物再生资源有限公司'], // 废钢回收加工企业
                // ['上海东亚期货有限公司', '中辉期货有限公司', '宏源期货有限公司', '徽商期货有限责任公司', '永安期货股份有限公司', '国投安信期货有限公司', '国泰君安期货有限公司', '银河期货有限公司', '国海良时期货有限公司', '中国国际期货股份有限公司'], // 期货企业
                // ['辽宁海力特种石油装备有限公司', '上海鸿网供应链股份有限公司', '中国检验认证集团河北有限公司', '钢谷电子商务股份有限公司', '德邻智联（鞍山）有限公司', '日照大宗商品交易中心', '中瑞和（天津）供应链管理服务有限公司', '唐山曹妃甸实业港务有限公司', '北京恒润九州实业有限公司', '秦皇岛佰工钢铁有限公司'], // 服务企业
                // ['厦门国贸集团股份有限公司', '唐山凯荣国际贸易有限公司', '中航国际钢铁贸易有限公司', '天津锦亿供应链管理有限公司', '嘉吉投资（中国）有限公司', '浙江物产金属集团有限公司', '河钢集团北京国际贸易有限公司', '山东建邦联合进出口有限公司', '山东环富国际贸易有限公司', '日照兴业集团有限公司'], //铁矿石供应商
                // ['唐山和朋贸易有限公司', '山东中垠国际贸易有限公司', '唐山永联国际贸易有限责任公司', '山东冀中瀚能供应链管理有限公司', '唐山市五山商贸有限公司', '厦门象屿股份有限公司', '易大宗（北京）供应链管理有限公司', '山东潍焦集团薛城能源有限公司', '山西省焦炭集团经销贸易有限公司', '重庆喜丰春瑞供应链管理有限公司'], // 煤焦供应商
                // ['天津瑞鑫昌科技有限公司', '河北港济实业有限公司', '河北港禾实业发展有限公司', '浙江开迪贸易有限公司', '江阴市铁实供应链有限公司', '上海俱丰供应链有限公司', '迁安市瑞虎商贸有限公司', '唐山市晨丰商贸有限公司', '天津市仁通钢铁有限公司', '唐山海瀚国际贸易有限公司'], // 钢坯供应商
                // ['唐山市丰润区乔羽贸易有限公司', '山西浩正鸿瑞贸易有限公司', '河北华贸电力新材料有限公司', '宁波荣城金属材料有限公司', '鞍山市鑫华通贸易有限公司', '唐山市丰润区超翼商贸有限公司', '邯郸市裕驰贸易有限公司', '泰安市延峰物资有限公司', '唐山市丰润区建源商贸有限公司', '唐山朗威进出口贸易有限公司'], // 型钢供应商
                // ['汇金工贸（天津）有限公司', '邯郸市钢盈贸易有限公司', '山东新乐华钢铁有限公司', '青岛鸿利宇供应链有限公司', '邯郸市泰虎贸易有限公司', '河北邯城贸易有限公司', '河北泰岳峰钢铁贸易有限公司', '唐山市炳旭实业有限公司', '中船重工物资贸易集团有限公司', '邯郸市晟德贸易有限公司'], // 板材供应商
                // ['辽宁紫中供应链有限责任公司', '河南豫之钢贸易有限公司', '万豪钢铁集团有限公司', '任丘市亚丰建筑器材有限公司', '中铁铁龙（营口）国际物流贸易有限公司', '唐山宏腾贸易有限公司', '陕钢集团韩城钢铁有限责任公司', '福建点增贸易有限公司', '山西兴合邦物资有限公司', '山东蓝天新材料科技有限公司'], // 建材供应商
                // ['天津市仁翼博爱国际商贸有限公司', '无锡市启升金属材料有限公司', '天津市宏英丰达金属材料销售有限公司', '瑞信国际贸易有限公司', '天津市智恒达商贸有限公司', '迁安市瑞虎商贸有限公司', '天津市丰隆商贸有限公司', '天津中拓电子商务有限公司', '上海塔杰实业有限公司', '天津勤兴敬业科技有限公司'], // 带钢供应商
                // ['天津市民阁商贸有限公司', '广州市华利丰钢材贸易有限公司', '南京友发物资有限公司', '奎鑫钢首集团', '唐山市青坤贸易有限公司', '霸州市广义制管有限公司', '天津海翼钢铁销售有限公司', '天津德汇钢铁贸易有限公司', '天津宏盛强钢铁有限公司', '天津市德健钢管有限公司'], // 钢管供应商
            ],
            sjDetailData: [],
            talkTab: 1
        }
    },
    mounted () {
        this.id = getQueryString('id');
        this.getAdByAdp();
        this.marqueeInit();
    },
    methods: {
        // 获取广告信息
        getAdByAdp () {
            const self = this;
            self.adIDsIndex.forEach((item, index) => {
                self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
                    if (res.code == 0) {
                        self.adIDsIndex[index]['list'] = res.data;
                    }
                })
            })
        },
        marqueeInit () {
            const self = this;
            $('.index-quote-list-box').liMarquee('destroy');
            setTimeout(() => {
                $('.index-quote-list-box').liMarquee({
                    // direction: 'up',
                    // loop: -1,
                    scrollamount: 30,
                    hoverstop: true,
                    circular: false
                });
            }, 500)
            
            
        },
        showImgDetail (index) {
            // console.log('进来了')
            this.dialogImg = this.imgs[index];
            // this.sjDetailData = this.imgsDetailNames[index];
            this.dialogVisible = true;
        },
        changeTalkTab (tab) {
            this.talkTab = tab;
        }
    }
    
}
</script>

<style scoped>
    @import url('../../assets/css/liMarquee.css');
    .content-bg {
        background: url('../../assets/images/ej/activeTopbg1.png') no-repeat;
        background-size: 100% auto;
        position: relative;
    }
    .logo-position {
        position: absolute;
        top: 60px;
        left: 60px;
        color: #fff;
    }
    .logo-position > p { font-size: 20px; }
    .logo-position > div > span { display: inline-block; margin-bottom: 20px; width: 8px; border-top: 2px solid #fff;}
    .mt10 { margin-top: 10px; }
    .mt40 { margin-top: 40px; }
    .mt30 { margin-top: 30px; }
    .mb15 { margin-bottom: 15px; }
    .title-text { font-size: 28px; letter-spacing: 10px; }
    .title-text-en { font-size: 20px; letter-spacing: 4px; font-weight: 100;}
    .time-text { 
        background: url('../../assets/images/ej/activeTimebg.png') no-repeat; 
        background-size: 100% 100%;
        line-height: 40px;
        width: 600px;
        font-size: 14px;
        font-weight: 600;
    }
    .meeting-jj {
        background: rgba(0, 0, 0, 0.4);
        font-size: 16px;
        color: #fff;
        line-height: 35px;
        width: 700px;
        padding: 20px 30px;
        letter-spacing: 1px;
        margin-top: 60px;
    }
    .meeting-jj-title {
        font-size: 20px;
        margin-bottom: 10px;
    }
    .meeting-yt {
        margin-top: 60px;
    }
    
    .meeting-yt-title {
        background: url('../../assets/images/ej/activeTitlebg1.png') no-repeat;
        background-size: 100% 100%;
        width: 1000px;
        height: 90px;
    }
    .meeting-yt-title1 {
        background: url('../../assets/images/ej/activeTitlebg2.png') no-repeat;
        background-size: 100% 100%;
    }
    .meeting-yt-title span {
        background-image: -webkit-linear-gradient(bottom, #ffc67d, #f6c195, #fbdcbf); 
        -webkit-background-clip: text; 
        -webkit-text-fill-color: transparent;
        line-height: 60px;
        font-size: 30px;
        font-weight: 600;
    }
    .meeting-yc-content {
        width: 1000px;
        box-sizing: border-box;
    }
    .meeting-yc-content > h2 {
        border-left: 10px solid #8e3837;
        padding-left: 20px;
        color: #8e3837;
    }
    .line { border-top: 1px solid #8e3837; margin-top: 10px; }
    .time-line-content { position: relative; margin-top: 40px; }
    .time-line-content span { display: inline-block; font-size: 16px; vertical-align: top; }
    .point {
        background: url('../../assets/images/ej/activeTimePoint.png') no-repeat;
        background-size: 100% 100%;
        width: 15px;
        height: 15px;
        margin: 0 30px;
        vertical-align: bottom;
        margin-top: 4px;
    }
    .right-text {
        color: #282828;
        margin-left: 30px;
        font-weight: 600;
        line-height: 30px;
        margin-top: -5px;
    }
    .time-line-content .right-intro {
        color: #282828;
        font-size: 14px;
        line-height: 40px;
    }
    .shuline {
        position: absolute;
        height: 80px;
        border-left: 1px solid #ccc;
        top: 20px;
        left: 136px;
    }
    .meeting-jbjs {
        border: 8px solid #ffc67d;
        box-sizing: border-box;
        width: 1000px;
        padding: 20px;
        color: #8e3837;
    }
    .detail-user-img { width: 100%; height: 200px;  }
    .index-quote-list-box { width: 1000px; height: 360px; overflow: hidden; box-sizing: border-box; border: 8px solid #ffc67d; margin: 30px auto; }
    .index-quote-list-box .img-box { padding: 30px 10px 10px 10px;  }
    .index-quote-list-box p { line-height: 40px; font-size: 16px; color: #8e3837; }
    .meeting-zanzhu { width: 1000px; }
    .zanzhu-title,
    .zanzhu-subtitle { color: #fd7744; font-size: 18px; }
    .zanzhu-subtitle { color: #fd7744; }
    .zanzhu-left,
    .zanzhu-center,
    .zanzhu-right { line-height: 35px; width: 100%; background: url('../../assets/images/ej/one1.png') no-repeat; background-size: 100% 100%; margin: 10px 0; font-size: 14px; color: #fff;}
    .zanzhu-center { background: url('../../assets/images/ej/two1.png') no-repeat; background-size: 100% 100%; }
    .zanzhu-right { background: url('../../assets/images/ej/three1.png') no-repeat; background-size: 100% 100%; }
    .meeting-address { padding-bottom: 30px; }
    .address-bg {
        /* background: url('../../assets/images/ej/addressbg.png') no-repeat;
        background-size: 100% 100%; */
        /* padding-top: 50px; */
        /* padding: 20px; */
        border: 8px solid #ffc67d;
        width: 1000px;
        margin: auto;
    }
    .address-bg img { width: 100%; }
    .meeting-concat { width: 1000px; }

    .tab-box {
        width: 1000px;
        margin: 60px auto 0 auto;
    }
    .tab-i {
        display: inline-block;
        width: 180px;
        height: 60px;
        background: url('../../assets/images/ej/activeTabBg.png') no-repeat;
        background-size: 100% 100%;
        margin: 10px;
        text-align: center;
        line-height: 50px;
        font-size: 16px;
        color: #f4e5c6;
        cursor: pointer;
        letter-spacing: 2px;
    }
    .tab-i:hover, .tab-i.active {
        font-weight: bold;
    }
</style> 